module.exports = __webpack_public_path__ + "img/person_2.8a74dafe.jpeg";